import { createUseStyles } from 'react-jss';
import { mixins } from '@/styles/mixins';
export const useStyles = createUseStyles((theme) => ({
    root: {},
    inputWrapper: {
        position: 'relative',
    },
    codePostfix: {
        fontSize: 13,
        color: theme.colors.textPrimary,
        fontWeight: 500,
        whiteSpace: 'nowrap',
        userSelect: 'none',
    },
    dropdownWrapper: {
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        zIndex: theme.zIndex.dropdown,
        marginTop: 4,
        backgroundColor: theme.colors.cloud,
        borderRadius: 12,
        boxShadow: theme.elevations[2],
        overflow: 'hidden',
    },
    dropdown: {
        padding: 3,
        maxHeight: 282,
        overflowY: 'auto',
        overscrollBehavior: 'contain',
        '&::-webkit-scrollbar': {
            width: 5,
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#485B75',
            borderRadius: 12,
        },
    },
    item: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '8px 8px',
        cursor: 'pointer',
        borderRadius: 8,
        transition: theme.transition.global,
        backgroundColor: theme.colors.cloud,
        border: 'none',
        '&:hover': {
            backgroundColor: theme.colors.brandTertiary,
        },
    },
    itemActive: {
        backgroundColor: theme.colors.brandTertiary,
    },
    itemIcon: {
        flexShrink: 0,
        width: 24,
        height: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.colors.textPrimary,
        '& svg': {
            width: 20,
            height: 20,
        },
    },
    itemContent: {
        flex: 1,
        minWidth: 0,
        textAlign: 'left',
    },
    itemMain: {
        display: 'flex',
        alignItems: 'baseline',
        gap: 4,
    },
    itemName: {
        fontSize: 14,
        fontWeight: 500,
        color: theme.colors.sky,
        lineHeight: '20px',
    },
    itemCode: {
        fontSize: 14,
        color: theme.colors.textPrimary,
        fontWeight: 400,
    },
    itemCity: {
        fontSize: 12,
        color: theme.colors.textPrimary,
        lineHeight: '18px',
        marginTop: 1,
    },
    dropdownButton: {
        padding: 10,
        ...mixins.centeredContent(),
        marginRight: -7,
        cursor: 'pointer',
        backgroundColor: 'transparent',
        border: 'none',
        '-webkit-tap-highlight-color': 'transparent',
        '& div': {
            ...mixins.centeredContent(),
        },
    },
    empty: {
        padding: '12px 16px',
        textAlign: 'center',
        fontSize: 14,
        color: theme.colors.sky,
    },
    loaderContainer: {
        padding: '24px 16px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}), { name: 'autocomplete' });
